import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { Button, Row, Col, Form, Input, FormGroup, Label } from "reactstrap";
import "./style.css";
import Api from "../../services/api";
import { changeIndexToNepali } from "../../utils";
import { FaCheckCircle, FaPrint, FaExclamationCircle } from "react-icons/fa";
import { BiCheck } from "react-icons/bi";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import FormPrint from "../../components/FormPrint";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as modalAction from "../../actions/modalAction";
import MainLoader from "../../components/MainLoader";
import ModalComp from "../../components/modals/ModalComp";
import ViewModal from "../../components/modals/ViewModal";
import AllComments from "./AllComments";

let localData = "";
let localData2 = "";
let fiscalYear = "";
let gnId = "";
if (JSON.parse(localStorage.getItem("user"))) {
  localData = JSON.parse(localStorage.getItem("user")).user.role_id;
  localData2 = JSON.parse(localStorage.getItem("user")).token;
  fiscalYear = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
  gnId = JSON.parse(localStorage.getItem("user")).user.ministry_id;
}

let gnids;

class SelfAssessmentForm extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.togBox = this.togBox.bind(this);
    this._getCategories = this._getCategories.bind(this);
    this._setAnwerDocs = this._setAnwerDocs.bind(this);
    this._sendRemarks = this._sendRemarks.bind(this);
    this._sendRemarks = _.debounce(this._sendRemarks, 1500);
    this._handleTextAreaChange = this._handleTextAreaChange.bind(this);
    this._compareOptions = this._compareOptions.bind(this);
    this._compareOptions2 = this._compareOptions2.bind(this);
    this.state = {
      activeTab: 1,
      activeTabIndex: 0,
      activeCategoryIndex: 0,
      categories: [],
      isLoading: true,
      answers: null,
      hasCompleted: {},
      isCompleted: {},
      answerDocs: {},
      print: false,
      remarksTicked: [],
      autoFocus: false,
      showBox: false,
      videoIndex: null,
      current_stage: null,
      ministry_name: [],
      internal_control_assessment: false,
    };
  }
  videoClickHandler = (index) =>
    this.setState((prevState) => ({
      videoIndex: prevState.videoIndex ? null : index,
    })); // if truthy videoIndex, set null, else, set index

  componentDidMount() {
    let { user } = this.props;
    this._getCategories();
    if (sessionStorage.getItem("tab")) {
      this.setState({ ...JSON.parse(sessionStorage.getItem("tab")) });
    }
    sessionStorage.removeItem("tab");
  }

  _setAnwerDocs(documentId, url) {
    const { user } = this.props;
    let { answerDocs } = this.state;
    if (user.hasSubmitted) return;
    answerDocs[documentId] = answerDocs[documentId]
      ? answerDocs[documentId]
      : {};
    answerDocs[documentId].url = url;
    this.setState({ answerDocs });
  }

  toggle(activeTabIndex, activeTab) {
    if (this.state.activeTab !== activeTab) {
      this.setState({
        activeTab,
        activeTabIndex,
      });
    }
  }
  togBox() {
    if (this.state.showBox == false) {
      this.setState({
        showBox: true,
      });
    } else if (this.state.showBox == true) {
      this.setState({
        showBox: false,
      });
    }

    // console.log(this.state.showBox);
  }

  async _getCategories() {
    const { user } = this.props;
    try {
      let response = await Api.getMinistryQuestions(
        user.fiscal_year_id,
        sessionStorage.getItem("provinceId"),
        user.ministry_id ? user.ministry_id : sessionStorage.getItem("m_id")
      );
      let categories = response.response.questions;

      sessionStorage.setItem('current_stage_id', response.response.current_stage_id);

      this.setState({
        categories,
        activeTab: categories[0].subCategories[0].id,
        firstTab: categories[0].subCategories[0].id,
        isLoading: false,
        current_stage: response.response.current_stage_id,
        ministry_name: response.response.ministry_name,
        internal_control_assessment:
          response.response.internal_control_assessment,
      });
      categories = this._setIsCompletedCategory(categories);
      if (user.role === "Ministry Data Entry") {
        categories = this._setDisabledCategory(categories);
      }
      this.setState({
        categories,
        activeTab: categories[0].subCategories[0].id,
        firstTab: categories[0].subCategories[0].id,
        isLoading: false,
        current_stage: response.response.current_stage_id,
        ministry_name: response.response.ministry_name,
        internal_control_assessment:
          response.response.internal_control_assessment,
      });
    } catch (e) {
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
      });
      this.setState({ isLoading: false });
    }
  }

  _setDisabledCategory = (categories) => {
    const { user } = this.props;
    let allowedCategories = user.categories;
    categories.map((category) => {
      if (allowedCategories.includes(category.id)) {
        category.isDisabled = false;
      } else {
        category.isDisabled = true;
      }
    });
    return categories;
  };

  _getDisabled = () => {
    const { user } = this.props;
    console.log("User form status", user);

    let disabled = false;
    if (
      user.role === "Ministry Admin (Focal Person)" ||
      (user.role === "Ministry Data Entry" && user.form_status > 0)
    ) {
      disabled = true;
    }
    if (user.role === "Ministry Approver (CAO)" && user.form_status === 0) {
      disabled = true;
    }
    if (user.role_id === 3 && this.state.current_stage === 4) {
      disabled = true;
    }
    if (user.role_id === 6 && this.state.current_stage === 4) {
      disabled = true;
    }
    if (user.form_status === 3) {
      disabled = true;
    }
    if (localData === 6 && this.state.current_stage === 3) {
      disabled = true;
    }
    return disabled;
  };

  _updateForm = async (
    activeCategory,
    subCategory,
    question,
    option,
    subCatIndex,
    qnIndex,
    sId
  ) => {
    let { categories, activeCategoryIndex } = this.state;
    let { user } = this.props;
    this.setState({ isLoading: true });
    try {
      let response = await Api.sendMinistryResponse({
        fiscal_year_id: user.fiscal_year_id ? user.fiscal_year_id : fiscalYear,
        question_id: question.id,
        option_id: option.id,
        score: option.marks,
        stage_id: sId,
        ministry_id: sessionStorage.getItem("m_id"),
        province: sessionStorage.getItem("provinceId"),
      });
      if (response.code === 200 || response.code === 204) {
        let updatedCategories = categories;
        updatedCategories[activeCategoryIndex].subCategories[
          subCatIndex
        ].questions[qnIndex].selected_option = option.id;
        updatedCategories = this._setIsCompletedCategory();
        this.setState({ categories: updatedCategories });
        this._getCategories();
        // window.location.reload(true);
      } else {
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (e) {
      debugger;
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
      });
    }

    this.setState({ isLoading: false });
    return;
  };

  _onNextClick = () => {
    window.scrollTo(0, 0);
    const { activeCategoryIndex, categories } = this.state;
    // debugger;
    let newActiveTab, newactiveCategoryIndex, newActiveTabIndex, newState;
    newActiveTabIndex = 0;
    newactiveCategoryIndex = activeCategoryIndex + 1;
    newActiveTab = categories[
      newactiveCategoryIndex
    ].subCategories[0].id.toString();
    newState = {
      activeCategoryIndex: newactiveCategoryIndex,
      activeTabIndex: newActiveTabIndex,
      activeTab: parseInt(newActiveTab),
    };
    this.setState({ ...newState, autoFocus: false });
  };

  _onPrevClick = () => {
    window.scrollTo(0, 0);
    const { activeCategoryIndex, categories } = this.state;
    let newActiveTab, newactiveCategoryIndex, newActiveTabIndex, newState;
    newActiveTabIndex = 2;
    newactiveCategoryIndex = activeCategoryIndex - 1;
    newActiveTab = categories[newactiveCategoryIndex].subCategories[
      categories[newactiveCategoryIndex].subCategories.length - 1
    ].id.toString();
    newState = {
      activeCategoryIndex: newactiveCategoryIndex,
      activeTab: parseInt(newActiveTab),
      activeTabIndex: newActiveTabIndex,
    };
    // return;
    this.setState({ ...newState, autoFocus: false });
  };

  _onCategoryClick(activeCategoryIndex) {
    window.scrollTo(0, 0);
    const { categories } = this.state;
    let activeTabIndex = 0;
    this.setState({
      activeCategoryIndex,
      activeTab:
        categories[activeCategoryIndex].subCategories[activeTabIndex].id,
      activeTabIndex,
      autoFocus: false,
    });
    this._getCategories();
  }

  _handleRemarksCheck = (e, question) => {
    let updatedRemarksTicked = [...this.state.remarksTicked];
    if (e.target.checked) {
      updatedRemarksTicked.push(question.id);
    } else {
      updatedRemarksTicked = updatedRemarksTicked.filter(
        (tickedQuestionId, i) => tickedQuestionId !== question.id
      );
    }
    this.setState({ remarksTicked: updatedRemarksTicked });
  };

  _handleTextAreaChange = async (
    e,
    question,
    activeCategoryIndex,
    subCatIndex,
    qnIndex,
    score,
    stage_id
  ) => {
    let { categories } = this.state;
    let activeCategory = categories[activeCategoryIndex];

    const { user } = this.props;

    activeCategory.subCategories[subCatIndex].questions[qnIndex].remarks =
      e.target.value;

    question.remarks = e.target.value;
    this.setState({ categories: categories });

    this._sendRemarks(question);
  };

  async _sendRemarks(question) {
    const { user } = this.props;

    let response = await Api.sendMinistryResponse({
      fiscal_year_id: user.fiscal_year_id ? user.fiscal_year_id : fiscalYear,
      question_id: question.id,
      remarks: question.remarks,
      ministry_id: user.ministry_id
        ? user.ministry_id
        : sessionStorage.getItem("m_id"),
      score: question.marks,
      stage_id: this.state.current_stage,
      province: sessionStorage.getItem("provinceId"),
      // option_id: question.id,
    });
    if (response.code !== 200) {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  _renderDocumentListFromOption(question) {
    console.log("first", this.current_stage);
    let documentList = [];
    let selectedOption = question.selected_option;
    if (selectedOption) {
      question.options.map((option) => {
        if (option.id === selectedOption) {
          if (option.documents.length === 0) {
            documentList.push(
              <p className="document-name document-empty" key={"no-doc"}>
                &bull; कुनैपनि प्रमाणीकरणको आधारहरु नचाहिने{" "}
                <FaCheckCircle className="check-circle-doc" color="#28a745" />
              </p>
            );
          }
          option.documents.map((document, i) => {
            let singleDoc;
            if (document !== "" && document.path !== "") {
              singleDoc = (
                <React.Fragment key={i++}>
                  {i === 1 ? <legend>प्रमाणीकरणको आधार:</legend> : ""}
                  <div className="d-flex">
                    <div className="mt-2">
                      <a onClick={() => (sessionStorage.getItem('current_stage_id') == 4) && (JSON.parse(localStorage.getItem('user')).user.role_id == 4) ? null : this._openDocumentModal(document)}>
                        <p className="document-name">
                          &bull; {document.name}
                        </p>
                      </a>
                      {this.state.current_stage === 5 && localData === 3 ? (
                        <FaCheckCircle
                          onClick={() => this._openDocumentModal(document)}
                          className="check-circle-doc"
                          color="#28a745"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    {<ViewModal remarks={document.path} />}
                  </div>
                </React.Fragment>
              );

            } else {
              singleDoc = (
                <a
                  onClick={() => this._openDocumentModal(document)}
                  key={document.id}
                >
                  <p className="document-name">
                    &bull; {document.name}
                    <FaExclamationCircle
                      className="check-circle-doc"
                      color="#e12a2a"
                    />
                  </p>
                </a>
              );
            }
            documentList.push(singleDoc);
            console.warn(singleDoc);
          });
        }
      });
    }
    return documentList;
  }

  // _renderDocumentListFromOption(question) {
  //   let documentList = [];
  //   let selectedOption = question.selected_option;
  //   if (selectedOption) {
  //     question.options.map((option) => {
  //       if (option.id === selectedOption) {
  //         if (option.documents.length === 0) {
  //           documentList.push(
  //             <p className="document-name document-empty" key={"no-doc"}>
  //               &bull; कुनैपनि प्रमाणीकरणको आधारहरु नचाहिने{" "}
  //               <FaCheckCircle className="check-circle-doc" color="#28a745" />
  //             </p>
  //           );
  //         }
  //         option.documents.map((document, i) => {
  //           let singleDoc;
  //           if (document !== "" && document.path !== "") {
  //             singleDoc = (
  //               <React.Fragment key={i++}>
  //                 <div>
  //                   {i === 1 ? <legend>प्रमाणीकरणको आधार:</legend> : ""}
  //                   <a>
  //                     <p className="document-name">
  //                       &bull; {document.name}
  //                       <FaCheckCircle
  //                         onClick={() => this._openDocumentModal(document)}
  //                         className="check-circle-doc"
  //                         color="#28a745"
  //                       />{" "}
  //                       <ViewModal remarks={document.path} />
  //                     </p>
  //                   </a>
  //                 </div>
  //               </React.Fragment>
  //             );
  //           } else {
  //             singleDoc = (
  //               <a
  //                 onClick={() => this._openDocumentModal(document)}
  //                 key={document.id}
  //               >
  //                 <p className="document-name">
  //                   &bull; {document.name}
  //                   <FaExclamationCircle
  //                     className="check-circle-doc"
  //                     color="#e12a2a"
  //                   />
  //                 </p>
  //               </a>
  //             );
  //           }
  //           documentList.push(singleDoc);
  //           console.warn(singleDoc);
  //           //if path==="" show exclaim else show tick and link to path.
  //         });
  //       }
  //     });
  //   }
  //   return documentList;
  // }

  _renderDocumentListFromOption2(question) {
    let documentList = [];
    // if (this.state.current_stage === 5 ? ) {
    //   let selectedOption = question.stage[1].selected_option;
    // } else {
    //   let selectedOption = question.stage[0].selected_option;
    // }
    let selectedOption =
      this.state.current_stage === 5
        ? question.stage[1].selected_option
        : question.stage[0].selected_option;
    if (selectedOption) {
      question.options.map((option) => {
        if (option.id === selectedOption) {
          option.documents.map((document, i) => {
            let singleDoc;
            if (document !== "" && document.path !== "") {
              singleDoc = (
                <React.Fragment key={i++}>
                  <div>
                    {i === 1 ? <legend>प्रमाणीकरणको आधार:</legend> : ""}
                    <a>
                      <p className="document-name">
                        &bull; {document.name}
                        <ViewModal remarks={document.path} />
                      </p>
                    </a>
                  </div>
                </React.Fragment>
              );
            } else {
              singleDoc = (
                <a key={document.id}>
                  <p className="document-name">
                    &bull; {document.name}
                    <FaExclamationCircle
                      className="check-circle-doc"
                      color="#e12a2a"
                    />
                  </p>
                </a>
              );
            }
            documentList.push(singleDoc);
            console.warn(singleDoc);
            //if path==="" show exclaim else show tick and link to path.
          });
        }
      });
    }
    return documentList;
  }

  _onDocumentRemoved = (removedDoc) => {
    let { categories } = this.state;
    categories.map((question) => {
      question.subCategories.map((subCat) => {
        return (
          subCat &&
          subCat.questions &&
          subCat.questions.map((question) => {
            question.options.map((option) => {
              option.documents.map((document) => {
                if (document.id === removedDoc.id) {
                  document.path = "";
                }
              });
            });
          })
        );
      });
    });
    categories = this._setIsCompletedCategory(categories);
    this.setState({ categories });
    //update cateegory obkect
  };

  _onDocumentUploaded = (uploadedDoc, response) => {
    let { categories } = this.state;
    categories.map((question) => {
      question.subCategories.map((subCat) => {
        return (
          subCat &&
          subCat.questions &&
          subCat.questions.map((question) => {
            question.options.map((option) => {
              option.documents.map((document) => {
                if (document.id === uploadedDoc.id) {
                  document.path = response.response.path;
                }
              });
            });
          })
        );
      });
    });
    categories = this._setIsCompletedCategory(categories);
    this.setState({ categories });

    //update cateegory obkect
  };

  _openDocumentModal = (document) => {
    const { onDocumentsShow } = this.props;
    onDocumentsShow({
      clickedDocument: document,
      onDocumentRemoved: this._onDocumentRemoved,
      onDocumentUploaded: this._onDocumentUploaded,
    });
  };

  _setIsCompletedCategory = (categoriesList) => {
    let { categories } = this.state;
    let categoryIsCompletedList =
      categories.length === 0 ? categoriesList : categories;
    categoryIsCompletedList.map((category) => {
      let isCatCompleted = true;
      category.subCategories.map((subCat) => {
        let isSubCatCompleted = true;
        return (
          subCat &&
          subCat.questions &&
          subCat.questions.map((question) => {
            let isQuestionCompleted = true;
            if (!question.selected_option) {
              isCatCompleted = false;
              isSubCatCompleted = false;
              isQuestionCompleted = false;
            } else {
              const selectedOptionObject = question.options.filter((option) => {
                return option.id === question.selected_option;
              });
              selectedOptionObject[0].documents.map((document) => {
                if (!document.path) {
                  isCatCompleted = false;
                  isSubCatCompleted = false;
                  isQuestionCompleted = false;
                }
              });
            }
            question.isCompleted = isQuestionCompleted;
          })
        );
        subCat.isCompleted = isSubCatCompleted;
      });
      category.isCompleted = isCatCompleted;
    });
    return categoryIsCompletedList;
  };

  _checkAllAnsCompleted = () => {
    let { categories } = this.state;
    let isCompleted = true;
    categories.map((category) => {
      if (!category.isCompleted) {
        isCompleted = false;
      }
    });
    return isCompleted;
  };

  _compareOptions = (a) => {
    // console.log(a);
    return a;
  };
  _compareOptions2 = (a) => {
    // console.log(a);
    return a;
  };

  render() {
    console.log("first state", this.state);

    document.onkeydown = function (t) {
      if (t.which == 9) {
        return false;
      }
    };
    let localData = "";
    let localData2 = "";
    let fiscalYear = "";
    let gnId = "";
    if (JSON.parse(localStorage.getItem("user"))) {
      localData = JSON.parse(localStorage.getItem("user")).user.role_id;
      localData2 = JSON.parse(localStorage.getItem("user")).token;
      fiscalYear = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
      gnId = JSON.parse(localStorage.getItem("user")).user.gnid;
    }
    const { handleSubmit, user } = this.props;

    let {
      categories,
      activeCategoryIndex,
      isLoading,
      answerDocs,
      remarksTicked,
      current_stage,
      activeTab,
      firstTab,
    } = this.state;
    let activeCategory = categories[activeCategoryIndex];
    console.log(this.state);

    let disabled = this._getDisabled();

    return (
      <MainLoader active={isLoading}>
        {categories.length > 0 && (
          <section className="assessment-form">
            <div className="header">
              <h1 className="heading">
                {this.state.ministry_name}(
                {this.state.categories.reduce(
                  (accumulator, current) =>
                    accumulator + current.obtained_marks,
                  0
                )}
                )
              </h1>{" "}
              {/*TODO show , district name from map data*/}
              <div>
                &nbsp;&nbsp;
                <ReactToPrint
                  trigger={() => (
                    <Button color="success" className="print-button" href="#">
                      <FaPrint className="print-icon" />
                      Print
                    </Button>
                  )}
                  content={() => this.componentRef}
                  onBeforePrint={() => console.log("on before")}
                  onAfterPrint={() => console.log("on after")}
                />
                <Button
                  onClick={() => this._openDocumentModal()}
                  className="uni-menu-item"
                >
                  कागजातहरु हेर्नुहोस
                </Button>
                &nbsp;&nbsp;
                <AllComments
                  user={user}
                  totalCount={20} />

              </div>
            </div>
            <Row>
              <br />
              <br />
              <Col sm="12 m-b-30">
                <div className="cat-heading-wrapper">
                  <h3 className="cat-heading">मूल्याङ्कन विषयक्षेत्रहरु</h3>
                </div>
                <Row>
                  {this.state.categories.map((category, catIndex) => {
                    const isImage =
                      category.image.match(/\.(jpeg|jpg|gif|png)$/) !== null;
                    return (
                      <Col key={category.id}>
                        <div
                          className={`cat-card ${activeCategoryIndex === catIndex ? "active" : ""
                            }`}
                          onClick={() => this._onCategoryClick(catIndex)}
                        >
                          <img
                            // src={
                            //   isImage
                            //     ? category.image
                            //     : require(`../../assets/images/${catIndex +
                            //         1}.svg`)
                            // }
                            src={category.image}
                            className="cat-icon"
                            alt="cat-icon"
                          />
                          <span className="comment-main-counter">
                            {category.comment_count}
                          </span>
                          <span
                            className="cat-name"
                            data-check={category.isCompleted}
                          >
                            {category.name}{" "}
                          </span>
                          {this.state.current_stage !== 5 &&
                            this.state.current_stage !== 7 &&
                            this.state.current_stage !== 3 && (
                              <>
                                {category.isCompleted ? (
                                  <FaCheckCircle
                                    className="check-circle"
                                    color="#28a745"
                                  />
                                ) : (
                                  <FaExclamationCircle
                                    className="check-circle"
                                    color="#e12a2a"
                                  />
                                )}
                              </>
                            )}
                          {(this.state.current_stage === 5 ||
                            this.state.current_stage === 7 ||
                            this.state.current_stage === 3) && (
                              <FaCheckCircle
                                className="check-circle"
                                color="#28a745"
                              />
                            )}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
              {activeCategory.subCategories && (
                <Col sm="12">
                  <Row className="question-card question-sticky">
                    <Col sm="6">
                      <legend className="form-qn2 floating-title">
                        <strong>मूल्याङ्कनका सूचकहरु </strong>
                      </legend>
                    </Col>
                    <Col col="6" className="form-tick-h">
                      <legend className="form-qn2 floating-title">
                        <strong>मन्त्रालयबाट प्रारम्भिक नतिजा</strong>
                      </legend>
                      <legend className="form-qn2 floating-title">
                        <strong>पृष्ठपोषण </strong>
                      </legend>
                      <legend className="form-qn2 floating-title">
                        <strong>
                          मन्त्रालयबाट पृष्ठपोषण हेरी अन्तिम नतिजा तयार{" "}
                        </strong>
                      </legend>
                    </Col>
                  </Row>
                  <div activeTab={this.state.activeTab}>
                    {activeCategory &&
                      activeCategory.subCategories &&
                      activeCategory.subCategories.map(
                        (subCategory, subCatIndex) => {
                          if (user.role === "Ministry Data Entry") {
                            disabled = !!activeCategory.isDisabled;
                          }
                          return (
                            <div tabId={subCategory.id} key={subCategory.id}>
                              <Row>
                                <Col sm="12">
                                  {/* commented because subCat might not be necessary */}
                                  <h4 className="subcat-header">
                                    {changeIndexToNepali(activeCategory.id)}.
                                    {changeIndexToNepali(subCatIndex + 1)}{" "}
                                    {subCategory.name}
                                  </h4>
                                  {subCategory &&
                                    subCategory.questions &&
                                    subCategory.questions.map(
                                      (question, qnIndex) => {
                                        let selectedOption =
                                          question.selected_option;
                                        return (
                                          <FormGroup
                                            className="question-card"
                                            tag="fieldset"
                                            key={question.id}
                                          >
                                            <Row>
                                              <Col sm="6">
                                                <legend className="form-qn">
                                                  {question.question}
                                                </legend>
                                                <div className="proof">
                                                  <Row>
                                                    {this.state
                                                      .current_stage === 2 ||
                                                      this.state.current_stage ===
                                                      4 ? (
                                                      <Col sm="12">
                                                        {this._renderDocumentListFromOption(
                                                          question
                                                        )}
                                                      </Col>
                                                    ) : (
                                                      <Col sm="12">
                                                        {this._renderDocumentListFromOption2(
                                                          question
                                                        )}
                                                      </Col>
                                                    )}

                                                    <Col sm="6">
                                                      {(this.state
                                                        .current_stage === 3 ||
                                                        this.state
                                                          .current_stage ===
                                                        4) &&
                                                        (localData === 4 ||
                                                          localData === 4) ? (
                                                        " "
                                                      ) : (
                                                        <div className="remarks-wrappers">
                                                          <label>
                                                            <input
                                                              disabled={
                                                                this.state
                                                                  .current_stage ===
                                                                  3 &&
                                                                  (localData ===
                                                                    4 ||
                                                                    localData ===
                                                                    2)
                                                                  ? disabled
                                                                  : false
                                                              }
                                                              type="checkbox"
                                                              onChange={(e) => {
                                                                return this._handleRemarksCheck(
                                                                  e,
                                                                  question
                                                                );
                                                              }}
                                                              checked={
                                                                !!question
                                                                  .stage[0]
                                                                  .remarks ||
                                                                remarksTicked.includes(
                                                                  question.id
                                                                )
                                                              }
                                                            />
                                                            &nbsp;&nbsp;&nbsp;{" "}
                                                            <br />
                                                          </label>
                                                          {(question.stage[0]
                                                            .remarks ||
                                                            remarksTicked.includes(
                                                              question.id
                                                            )) && (
                                                              <textarea
                                                                rows="2" cols="50"
                                                                name="textarea"
                                                                disabled={
                                                                  this.state
                                                                    .current_stage ===
                                                                    3 &&
                                                                    localData === 4
                                                                    ? disabled
                                                                    : false
                                                                }
                                                                defaultValue={
                                                                  question
                                                                    .stage[0]
                                                                    .remarks
                                                                }
                                                                onChange={(e) =>
                                                                  this._handleTextAreaChange(
                                                                    e,
                                                                    question,
                                                                    activeCategoryIndex,
                                                                    subCatIndex,
                                                                    qnIndex
                                                                  )
                                                                }
                                                              ></textarea>
                                                            )}
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </Col>
                                              {console.log(
                                                "question.stage",
                                                question.stage,
                                                disabled
                                              )}
                                              {question.stage.map(
                                                (stages, i) => (
                                                  <>
                                                    <Col
                                                      className={
                                                        i === 0 &&
                                                          localData === 4 &&
                                                          this.state
                                                            .current_stage === 2
                                                          ? "enabled"
                                                          : i === 1 &&
                                                            (localData === 8 ||
                                                              localData ===
                                                              6) &&
                                                            this.state
                                                              .current_stage ===
                                                            3
                                                            ? "enabled"
                                                            : i === 1 &&
                                                              this.state
                                                                .current_stage ===
                                                              4 &&
                                                              localData === 3
                                                              ? "enabled"
                                                              : i === 3 &&
                                                                localData === 2 &&
                                                                this.state
                                                                  .current_stage ===
                                                                4
                                                                ? "enabled "
                                                                : "disabled-ques"
                                                      }
                                                      sm="2"
                                                    >
                                                      {i === 0 && (
                                                        <Col>
                                                          {question &&
                                                            question.options &&
                                                            question.options.map(
                                                              (item) => (
                                                                <div>
                                                                  <FormGroup className="position-relative form-check">
                                                                    <Label className="form-check-label">
                                                                      <Input
                                                                        id={`radio-${stages.id.toString() +
                                                                          question.id.toString()}`}
                                                                        type="radio"
                                                                        name={`radio-${stages.id.toString() +
                                                                          question.id.toString()}`}
                                                                        data-opt={
                                                                          item.id
                                                                        }
                                                                        data-marks={
                                                                          item.marks
                                                                        }
                                                                        defaultChecked={
                                                                          stages.selected_option ===
                                                                          item.id
                                                                        }
                                                                        onChange={() =>
                                                                          this._updateForm(
                                                                            activeCategory,
                                                                            subCategory,
                                                                            question,
                                                                            item,
                                                                            subCatIndex,
                                                                            qnIndex,
                                                                            stages.id
                                                                          )
                                                                        }
                                                                      />
                                                                      {console.log(
                                                                        "first stage id top",
                                                                        stages.id
                                                                      )}
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </Label>
                                                                  </FormGroup>
                                                                </div>
                                                              )
                                                            )}
                                                        </Col>
                                                      )}
                                                      {i === 1 && (
                                                        <Col sm="2">
                                                          {question.updated_by && (
                                                            <span className="updated-by">
                                                              <b>
                                                                {
                                                                  question.updated_by
                                                                }
                                                              </b>
                                                              द्वारा{" "}
                                                              <b>
                                                                {new Date(
                                                                  question.updated_at
                                                                ).toLocaleDateString(
                                                                  "ne-NP",
                                                                  {
                                                                    day:
                                                                      "numeric",
                                                                    month:
                                                                      "short",
                                                                    year:
                                                                      "numeric",
                                                                  }
                                                                )}
                                                              </b>
                                                              मा अद्यावधिक
                                                              गरिएको
                                                            </span>
                                                          )}
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "center",
                                                              alignItems:
                                                                "center",
                                                              gap: "4px",
                                                              paddingTop:
                                                                "30px",
                                                            }}
                                                          >
                                                            <ModalComp
                                                              comment={true}
                                                              stage_id={
                                                                question.comment_count
                                                              }
                                                              gnid={gnId}
                                                              token={localData2}
                                                              question_id={
                                                                question.id
                                                              }
                                                              fiscalYear={
                                                                fiscalYear
                                                              }
                                                              state={{
                                                                activeCategoryIndex: this
                                                                  .state
                                                                  .activeCategoryIndex,
                                                                activeTab: this
                                                                  .state
                                                                  .activeTab,
                                                              }}
                                                            />
                                                          </div>
                                                        </Col>
                                                      )}
                                                    </Col>
                                                    <Col
                                                      sm={"2"}
                                                      className={
                                                        i === 0
                                                          ? "enabled none"
                                                          : i === 1 &&
                                                            localData === 3 &&
                                                            this.state
                                                              .current_stage ===
                                                            4
                                                            ? "enabled"
                                                            : i === 2 &&
                                                              this.state
                                                                .current_stage ===
                                                              4
                                                              ? "enabled"
                                                              : i === 1 &&
                                                                localData === 3 &&
                                                                this.state
                                                                  .current_stage ===
                                                                4
                                                                ? "enabled"
                                                                : "disabled-ques"
                                                      }
                                                    >
                                                      {console.log(
                                                        "radio",
                                                        stages.id.toString()
                                                      )}

                                                      {i === 1 && (
                                                        <div>
                                                          {question &&
                                                            question.options.map(
                                                              (item) => (
                                                                <div>
                                                                  <FormGroup className="position-relative form-check">
                                                                    <Label className="form-check-label">
                                                                      <Input
                                                                        id={`radio-${stages.id.toString() +
                                                                          question.id.toString()}`}
                                                                        type="radio"
                                                                        name={`radio-${stages.id.toString() +
                                                                          question.id.toString()}`}
                                                                        data-opt={
                                                                          item.id
                                                                        }
                                                                        data-marks={
                                                                          item.marks
                                                                        }
                                                                        defaultChecked={
                                                                          stages.selected_option ===
                                                                          item.id
                                                                        }
                                                                        onChange={() =>
                                                                          this._updateForm(
                                                                            activeCategory,
                                                                            subCategory,
                                                                            question,
                                                                            item,
                                                                            subCatIndex,
                                                                            qnIndex,
                                                                            stages.id
                                                                          )
                                                                        }
                                                                      />
                                                                      {console.log(
                                                                        "first stage id bottom",
                                                                        stages.id
                                                                      )}
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </Label>
                                                                  </FormGroup>
                                                                </div>
                                                              )
                                                            )}
                                                        </div>
                                                      )}
                                                    </Col>
                                                    {console.log("i", i)}
                                                  </>
                                                )
                                              )}
                                              {console.log(
                                                "localData",
                                                localData
                                              )}
                                              {console.log(
                                                "current_stage",
                                                current_stage
                                              )}
                                              {question.stage.map((stages, i) =>
                                                i === 0 &&
                                                  current_stage === 2 ? (
                                                  this._compareOptions(
                                                    i === 0 &&
                                                    stages.selected_option
                                                  ) ===
                                                    this._compareOptions2(
                                                      question.selected_option
                                                    ) ? (
                                                    ""
                                                  ) : question.selected_option ===
                                                    "" ? (
                                                    ""
                                                  ) : (
                                                    <div className="if-same-pop">
                                                      <p>
                                                        पृष्ठपोषण गर्नुहोस्।
                                                      </p>
                                                    </div>
                                                  )
                                                ) : (
                                                  ""
                                                )
                                              )}
                                            </Row>
                                          </FormGroup>
                                        );
                                      }
                                    )}
                                </Col>
                              </Row>
                            </div>
                          );
                        }
                      )}
                    {activeCategoryIndex === 0 && activeTab === firstTab ? (
                      ""
                    ) : (
                      <Button className="previous" onClick={this._onPrevClick}>
                        <p>अघिल्लो</p>
                      </Button>
                    )}
                    <div className="right-button">
                      {activeCategoryIndex === categories.length - 1 ? (
                        <Button
                          className="next"
                          onClick={() => this.props.history.goBack()}
                        >
                          <p>समाप्त</p>
                        </Button>
                      ) : (
                        <Button className="next" onClick={this._onNextClick}>
                          <p>अर्को</p>
                        </Button>
                      )}
                    </div>
                  </div>
                </Col>
              )}
            </Row>

            <FormPrint
              categories={categories}
              answerDocs={answerDocs}
              remarksTicked={remarksTicked}
              ref={(el) => (this.componentRef = el)}
            />
            <ToastContainer />
          </section>
        )}
      </MainLoader>
    );
  }
}

SelfAssessmentForm = reduxForm({
  // a unique name for the form
  form: "selfAssessment",
})(SelfAssessmentForm);

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  onDocumentsShow: (modalProps) => {
    dispatch(
      modalAction.processModal(
        modalAction.SHOW_MODAL,
        modalAction.ModalTypes.SHOW_DOCUMENT,
        modalProps
      )
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SelfAssessmentForm);
